export default "__VITE_ASSET__fc5fe31f__"